import React from 'react';

interface JobIconProps {
  name: string;
  size?: number;
  className?: string;
}

export const JobIcon: React.FC<JobIconProps> = ({ name, size = 64, className = '' }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 64 64" 
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="32" cy="32" r="30" fill="#4A90E2" stroke="#2E5A8A" strokeWidth="2"/>
      <text 
        x="32" 
        y="38" 
        textAnchor="middle" 
        fontSize="12" 
        fill="white" 
        fontWeight="bold"
      >
        {name.substring(0, 3).toUpperCase()}
      </text>
    </svg>
  );
};